// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
    LoadRelatedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { CustomAppState } from "@synd/App/Store/Reducers";
import { delay } from "@synd/XDL/Utilities";

const XLoadFeaturedProducts = (props: any) => {
    const {
        parameter: { carouselType, productNumbers },
    } = props;
    // Add product numbers incase we have featured carousel
    props.getProductCollectionParameter = {
        ...props.getProductCollectionParameter,
        ...(carouselType === "featuredProducts" && {
            productNumbers,
            pageSize: Math.min(16, productNumbers?.length || 0),
        }),
    };
};

export const XNGLoadProducts: typeof LoadProducts = async ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    additionalSort,
    parameter: { carouselId, carouselType, numberOfProductsToDisplay, isProductDetailsPage, productId, isShellEdit },
    // XNG-Change
    getState,
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges", "properties")
        : (getProductCollectionParameter.expand = ["images", "badges", "properties"]);

    // <XNG-Change> refetch recently viewed
    const lastTimeRecentlyViewed = (getState() as CustomAppState).xCommon.lastTimeRecentlyViewed;
    const time = Date.now();
    if (carouselType === "recentlyViewed") {
        const isExceed = lastTimeRecentlyViewed ? time - lastTimeRecentlyViewed >= 30000 : true;
        if (isExceed) {
            dispatch({
                type: "xCommon/update",
                data: {
                    key: "lastTimeRecentlyViewed",
                    value: time,
                },
            } as any);
            // Clean up previous one if any
            if (lastTimeRecentlyViewed) {
                dispatch({
                    type: "Data/Products/CompleteLoadProducts",
                    collection: { products: [] } as any,
                    parameter: { ...getProductCollectionParameter, time: lastTimeRecentlyViewed },
                });
            }
            (getProductCollectionParameter as any).time = time;
            await delay(100);
        } else {
            (getProductCollectionParameter as any).time = lastTimeRecentlyViewed;
        }
    }
    // </XNG-Change>
    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit,
            additionalSort,
        }),
    );
};

addToChainBefore(chain, LoadRelatedProducts, XLoadFeaturedProducts);
replaceInChain(chain, LoadProducts, XNGLoadProducts);
